let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fh5Z6")).then(() => parcelRequire('8pSOn'));